import * as React from 'react';

type RightArrowProps = {
  size?: number | string;
  title?: string;
  className?: string;
  style?: React.CSSProperties;
  color?: string;
};

function RightArrowIcon({
  size = 18,
  title = 'Right arrow',
  className,
  style,
  color = 'white',
}: RightArrowProps) {
  const s = typeof size === 'number' ? `${size}px` : size;

  // Flat horizontal shaft with a longer arrow head
  return (
    <span
      role='img'
      aria-label={title}
      title={title}
      className={className}
      style={{
        display: 'inline-block',
        width: s,
        height: s,
        lineHeight: 0,
        ...style,
      }}
    >
      <svg width='100%' height='100%' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' aria-hidden focusable='false'>
        <path fillRule='evenodd' clipRule='evenodd' d='M20.9004 11.9996C20.9004 12.2383 20.8056 12.4672 20.6368 12.636L15.1368 18.136C14.7853 18.4875 14.2155 18.4875 13.864 18.136C13.5125 17.7845 13.5125 17.2147 13.864 16.8632L17.8276 12.8996L4.00039 12.8996C3.50333 12.8996 3.10039 12.4967 3.10039 11.9996C3.10039 11.5026 3.50333 11.0996 4.00039 11.0996L17.8276 11.0996L13.864 7.13601C13.5125 6.78453 13.5125 6.21468 13.864 5.86321C14.2155 5.51174 14.7853 5.51174 15.1368 5.86321L20.6368 11.3632C20.8056 11.532 20.9004 11.7609 20.9004 11.9996Z' fill={color} />
      </svg>
    </span>
  );
}

export default RightArrowIcon;
